import React from 'react';
import DeleteIcon from 'assets/Icons/delete/DeleteIcons';
import BackIcon from 'assets/Icons/modals/BackIcon';
import PrimaryButton from 'components/elements/Form/button/primaryButton';
import SecondaryButton from 'components/elements/Form/button/secondaryButton';
import Modal from 'components/elements/Modal';
import useDeleteAccount from './crud/useDelete';
import { AccountProps } from 'services/hooks/account-service';

/* The below type defines the props required for a delete component in a TypeScript React application. */
type DeleteProps = {
  entityName: string;
  showModal: boolean;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  setDeleteUUID: React.Dispatch<React.SetStateAction<string>>;
  deleteUUID?: string;
  deleteQuery: (uuid: string | undefined) => Promise<AccountProps>;
  queryName: string;
};

export default function Delete({
  entityName,
  showModal,
  setShowModal,
  setDeleteUUID,
  deleteUUID,
  deleteQuery,
  queryName
}: DeleteProps) {
  /* The `deleteAccountMutation` variable is created using the `useDeleteAccount` hook. 
  This hook is responsible for handling the logic of deleting an Account. */
  const deleteAccountMutation = useDeleteAccount({
    deleteQuery,
    queryName,
    onSuccess: () => {
      setShowModal(false);
      setDeleteUUID('');
    },
    removeOnSuccess: true
  });

  return (
    <>
      <Modal
        isOpen={showModal}
        onRequestClose={() => {
          setShowModal(false);
          if (setDeleteUUID) setDeleteUUID('');
        }}
      >
        <div className="flex flex-col items-center">
          <div className="delete-icon">
            <DeleteIcon />
          </div>
          <h1 className="mt-4">Are you sure?</h1>
          <p>{`Are you sure you want to delete this ${entityName.toLowerCase()}?`}</p>
          <div className="flex justify-between space-x-2">
            <SecondaryButton
              buttonLabel="Back"
              iconLeft={<BackIcon />}
              variant="default"
              size="px-4 w-auto"
              onClick={() => {
                setShowModal(false);
                setDeleteUUID('');
              }}
            />
            <PrimaryButton
              buttonLabel="Delete"
              onClick={() => deleteAccountMutation.mutate(deleteUUID)}
              variant="default"
              size="px-4 w-auto gap-2"
            />
          </div>
        </div>
      </Modal>
    </>
  );
}
